/**
 * External dependencies
 */
import React from 'react';
import ContentLoader from 'react-content-loader';

/**
 * Internal dependencies
 */
import { Stack } from '@towersystems/towersystems-design-system';
import Card from 'components/card';

const Loader = () => {
    return (
        <Stack space="xxlarge">
            <Card padding='xlarge'>
                <ContentLoader speed={2} height={50} width='100%' backgroundColor='#f3f3f3' foregroundColor='#ecebeb'>
                    <rect x='70' y='8' rx='3' ry='3' width='100%' height='10' />
                    <rect x='70' y='26' rx='3' ry='3' width='100%' height='10' />
                    <circle cx='25' cy='25' r='25' />
                </ContentLoader>
            </Card>
            <Card padding='xlarge'>
                <ContentLoader speed={2} height={50} width='100%' backgroundColor='#f3f3f3' foregroundColor='#ecebeb'>
                    <rect x='70' y='8' rx='3' ry='3' width='100%' height='10' />
                    <rect x='70' y='26' rx='3' ry='3' width='100%' height='10' />
                    <circle cx='25' cy='25' r='25' />
                </ContentLoader>
            </Card>
            <Card padding='xlarge'>
                <ContentLoader speed={2} height={50} width='100%' backgroundColor='#f3f3f3' foregroundColor='#ecebeb'>
                    <rect x='70' y='8' rx='3' ry='3' width='100%' height='10' />
                    <rect x='70' y='26' rx='3' ry='3' width='100%' height='10' />
                    <circle cx='25' cy='25' r='25' />
                </ContentLoader>
            </Card>
        </Stack>
    );
};

export default Loader;
